import { getSupabaseConfig } from "@/lib/supabase/client";

function requiredConfig() {
  const { url, anonKey } = getSupabaseConfig();
  if (!url || !anonKey) {
    throw new Error("Supabase ayarları eksik. VITE_SUPABASE_URL ve VITE_SUPABASE_ANON_KEY gerekli.");
  }
  return { url, anonKey };
}

export type SupabaseHealthResult = {
  ok: boolean;
  status: number;
  message: string;
};

async function probe(url: string, anonKey: string, path: string) {
  const res = await fetch(`${url}${path}`, {
    method: "GET",
    headers: {
      apikey: anonKey,
      Authorization: `Bearer ${anonKey}`,
    },
  });

  return res;
}

export async function checkSupabaseHealth(): Promise<SupabaseHealthResult> {
  const { url, anonKey } = requiredConfig();

  try {
    const rest = await probe(url, anonKey, "/rest/v1/");
    if (rest.status > 0) {
      return {
        ok: rest.status < 500,
        status: rest.status,
        message: rest.status < 500 ? "Ulaşılıyor" : "Sunucu hatası",
      };
    }
  } catch {
    // try next endpoint
  }

  try {
    const auth = await probe(url, anonKey, "/auth/v1/health");
    return {
      ok: auth.status > 0 && auth.status < 500,
      status: auth.status || 0,
      message: auth.status > 0 ? "Ulaşılıyor" : "Ulaşılamıyor",
    };
  } catch (err) {
    const message = err instanceof Error ? err.message : "Ulaşılamıyor";
    return { ok: false, status: 0, message };
  }
}
